import { Component, input, output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

export type TooltipCommonType = 'info' | 'alert';

@Component({
  selector: 'cue-tooltip',
  imports: [NgTemplateOutlet],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  host: {
    '[class.info]': 'commonType() === "info"',
    '[class.alert]': 'commonType() === "alert"',
  },
})
export class TooltipComponent<TContext> {
  commonType = input<TooltipCommonType | undefined>();
  template = input<TemplateRef<TContext> | undefined>();
  templateContext = input<TContext | undefined>();
  text = input<string | undefined>();

  tooltipBlur = output();

  onBlur() {
    this.tooltipBlur.emit();
  }
}
